import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useLocation } from "react-router-dom";

interface MenuProps {
  black: boolean;
}

const Nav = ({ black }: MenuProps) => {
  const location = useLocation();

  return (
    <>
      {" "}
      <span className="nav" />
      <header className={black ? "black" : ""}>
        <div className="MenuConteiner">
          <div className="MenuInitial">
            <a
              className="BtnCurriculo"
              href="https://drive.google.com/u/1/uc?id=1hxaPXtkH5uAJjXCL_CgccqYaVX8nCz3q&export=download"
            >
              Baixar Curriculo
            </a>
          </div>

          {location.pathname === "/" ? (
            <nav className="MenuLinks">
              <li>
                <a href="#SobreMim"> Sobre Mim </a>
              </li>
              <li>
                <a href="#Projetos"> Projetos </a>
              </li>
              <li>
                <a href="#Habilidades"> Conhecimentos </a>
              </li>
            </nav>
          ) : (
            <a href="/">Home</a>
          )}
        </div>
      </header>
    </>
  );
};
export default Nav;
